import type { FetchModelResponse } from '@cian/http-api';
import { UnknownError } from '@cian/peperrors/shared';

import { TGetInfrastructureResponse } from '../../../repositories/infrastructure-caching/v4/get-infrastructure';
import { IGetInfrastructureV4Response } from '../../../repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4Response';

export function assertUnknownError(
  response: TGetInfrastructureResponse,
): asserts response is FetchModelResponse<200, 'json', IGetInfrastructureV4Response> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/getInfrastructure#assertUnknownError()',
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
}
